import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-signup',
  templateUrl: './auth-signup.component.html',
  styleUrls: ['./auth-signup.component.css'],
  standalone: false,
})
export class AuthSignupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
